module.exports = __webpack_public_path__ + "static/media/selfAudio.e786a866.m4a";